import './common-styles';
import '@/styles/dmq-product.scss';

import './common-code';
import DmqProductImageSwiper from '@/components/DmqProductImageSwiper';
import DmqProductActions from '@/components/DmqProductActions.vue';
import store from '@/store/index';
import DmqMap from '@/components/DmqMap';

import '@/components/DmqAccordion';
import DmqRemainingTime from '@/components/DmqRemainingTime';


const imageSwiper = new DmqProductImageSwiper();

const thumbnails = document.querySelectorAll('.dmq-product-images-thumbnail');
thumbnails.forEach((e, index) => {
  const he = e as HTMLElement;
  he.onclick = () => {
    imageSwiper.slideTo(index);
  };
});

imageSwiper.on('slideChange', () => {
  thumbnails.forEach((e, index) => {
    const he = e as HTMLElement;
    if (index === imageSwiper.activeIndex) {
      he.classList.add('dmq-product-images-thumbnail--active');
    } else {
      he.classList.remove('dmq-product-images-thumbnail--active');
    }
  });
});

document.querySelectorAll('.dmq-product-variant-select').forEach((e) => {
  const se = e as HTMLSelectElement;
  se.onchange = () => {
    window.location.pathname = '/shop/product/' + se.options[se.selectedIndex].value;
  };
});

const actionsEl = document.getElementById('dmq-product-actions') as HTMLElement;

if (actionsEl) {
  const product = JSON.parse(actionsEl.dataset.product || '');
  new DmqProductActions({
    store,
    propsData: {
      pageProduct: product,
      addToCartLabel: actionsEl.dataset.addToCartLabel,
      maxOrderedLabel: actionsEl.dataset.maxOrderedLabel,
      notAvailableLabel: actionsEl.dataset.notAvailableLabel,
    },
  }).$mount(actionsEl);
}

const desktopMap = new DmqMap(document.getElementById('dmq-product-retailer-map-desktop') as HTMLElement);
const mobileMap = new DmqMap(document.getElementById('dmq-product-retailer-map-mobile') as HTMLElement);
const mobileMapToggle = document.getElementById('dmq-retailer-map-toggle-mobile') as HTMLElement;

mobileMapToggle.addEventListener('click', (ev) => {
  mobileMap.map.invalidateSize();
});

document.querySelectorAll('.dmq-tab__link').forEach((el) => {
  const tabLinkEl = el as HTMLElement;
  const tabsEl = tabLinkEl.closest('.dmq-tabs') as HTMLElement;
  const tabLinkEls =  tabsEl.querySelectorAll('.dmq-tab__link');
  const paneIds = (tabLinkEl.dataset.toggles || '').split(',');
  tabLinkEl.onclick = (ev) => {
    ev.preventDefault();

    // Link activation
    const allPanesIds: string[] = [];
    tabLinkEls.forEach((te) => {
      const tle = te as HTMLElement;
      tle.classList.remove('dmq-tab__link--active');
      (tle.dataset.toggles || '').split(',').forEach((pid) => {
        allPanesIds.push(pid);
      });
    });
    tabLinkEl.classList.add('dmq-tab__link--active');

    // Panes activation
    allPanesIds.forEach((pid) => {
      (document.getElementById(pid) as HTMLElement).classList.remove('dmq-pane--active');
    });
    paneIds.forEach((pid) => {
      (document.getElementById(pid) as HTMLElement).classList.add('dmq-pane--active');
    });

    // Ensure map update
    desktopMap.map.invalidateSize();

    return false;
  };
});

document.querySelectorAll<HTMLElement>('.dmq-product-flash-sale-rtime').forEach((el) => {
  const _ = new DmqRemainingTime(el);
});


